import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-92" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-93" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-94" data-mp="3ghc2o28413o8">
          Baseball Practice Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-95" data-mp="36p6cmy1f4wbo">
          The Print-and-Coach System — so you never walk onto the field without
          knowing exactly what to do.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-96" data-mp="38h5b9u0hiky">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-white hover:underline" data-id="element-97" data-mp="3lelybzm3ebki">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-white hover:underline" data-id="element-98" data-mp="3qfjhofiu9bnl">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-white hover:underline" data-id="element-99" data-mp="2eya1c1v0azqi">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-100" data-mp="3l8qxu8j60rtk">
          Baseball Practice Ready is an educational resource for coaches. It does
          not replace coach certification, CPR/first-aid training, or the rules
          of your league or governing body. Coaches are responsible for making
          sure any drill or skill is supervised, age-appropriate and safe for
          their players before it is run. Not affiliated with or endorsed by
          Little League, MLB or any other organization.
          &copy; Baseball Practice Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}